import { render } from "./StatistiqueGlobal.vue?vue&type=template&id=b6e4911e&ts=true"
import script from "./StatistiqueGlobal.vue?vue&type=script&lang=ts"
export * from "./StatistiqueGlobal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__